/* eslint-disable */
class BrowserGeolocationService {
  constructor (callback, errorCallback, ENABLE_HIGH_ACCURACY = true, MAXIMUM_AGE = 30000, TIMEOUT = 27000) {
    this.trackingId = 0

    this.callback = (location) => {
      callback(location)
    }

    this.errorCallback = errorCallback

    this.GEOLOCATION_OPTIONS = {
      ENABLE_HIGH_ACCURACY,
      MAXIMUM_AGE,
      TIMEOUT
    }
  }

  // For one off location requests
  getPosition (callback = this.callback, errorCallback = this.errorCallback) {
    // console.log('Fetching position in non-tracking mode.')
    return navigator.geolocation.getCurrentPosition(callback, errorCallback, this.GEOLOCATION_OPTIONS)
  }

  startTracking (callback = this.callback) {
    this.trackingId = navigator.geolocation.watchPosition(callback, this.errorCallback, this.GEOLOCATION_OPTIONS)
    // console.log(`Starting background Geolocation tracking with watchId ${this.trackingId}`)
  }

  stopTracking () {
    // console.log('Stopping background Geolocation tracking')
    navigator.geolocation.clearWatch(this.trackingId)
  }
}

class DeviceGeolocationService {
  constructor (callback, errorCallback, desiredAccuracy = 100, distanceFilter = 5) {
    let bgGeo = global.backgroundGeolocation
    this.bgGeo = bgGeo

    this.callback = function (location, finishBg = true) {
      callback(location)
    }

    this.bgGeo.configure(this.callback, errorCallback, {
      desiredAccuracy,
      distanceFilter,
      maxLocations: 1000
    })

    bgGeo.watchLocationMode(
      function (enabled) {
        if (enabled) {
          // console.log('Location enabled')
        } else {
          // console.log('Location not enabled')
        }
      },
      function (error) {
        // console.log('Error watching location mode. Error:' + error)
      }
    )

    bgGeo.isLocationEnabled(function (enabled) {
      if (enabled) {
        // console.log('Location enabled')
      } else {
        // Location services are disabled
        if (window.confirm('Location is disabled. Would you like to open location settings?')) {
          bgGeo.showLocationSettings()
        }
      }
    })
  }

  stopTracking () {
    // console.log('Stopping background Geolocation tracking')
    this.bgGeo.stop()
  }

  startTracking () {
    this.bgGeo.start(
      function () {
        // console.log('Starting background GeoLocation tracking')
      },
      function (error) {
        if (error.code === 2) {
          if (window.confirm('Not authorized for location updates. Would you like to open app settings?')) {
            this.bgGeo.showAppSettings()
          }
        } else {
          window.alert('Start failed: ' + error.message)
        }
      }
    )
  }

  // TODO Clean this up. I'm using the Cordova Geolocation polyfill for single location requests
  getPosition (callback = this.callback, errorCallback = this.errorCallback,
    ENABLE_HIGH_ACCURACY = true, MAXIMUM_AGE = 30000, TIMEOUT = 27000) {
    // console.log('Fetching position in non-tracking mode.')
    return navigator.geolocation.getCurrentPosition(this.callback, this.errorCallback, {
      ENABLE_HIGH_ACCURACY,
      MAXIMUM_AGE,
      TIMEOUT
    })
  }

  // Check if location is enabled
  locationEnabled (successCallback, failureCallback) {
    return this.bgGeo.isLocationEnabled(successCallback, failureCallback)
  }
}

export default {
  BrowserGeolocationService,
  DeviceGeolocationService
}
